import * as St from './InvoiceLine.styles';

interface InvoiceLineProps {
  size?: 'small' | 'large';
  color?: 'green' | 'red';
  label?: string;
  value?: string;
}

const InvoiceLine = ({
  size = 'small',
  color,
  label,
  value,
}: InvoiceLineProps) => (
  <St.Container data-size={size} data-color={color}>
    {label ? <St.Label>{label}</St.Label> : null}
    {value ? <St.Value>{value}</St.Value> : null}
  </St.Container>
);

export default InvoiceLine;
